module.exports = __webpack_public_path__ + "img/wechat.81468932.jpg";